/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ResistanceTrend from './resistance-trend';
import ResistanceTrendDetail from './resistance-trend-detail';
import ResistanceTrendUpdate from './resistance-trend-update';
import ResistanceTrendDeleteDialog from './resistance-trend-delete-dialog';

const ResistanceTrendRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ResistanceTrend />} />
    <Route path="new" element={<ResistanceTrendUpdate />} />
    <Route path=":id">
      <Route index element={<ResistanceTrendDetail />} />
      <Route path="edit" element={<ResistanceTrendUpdate />} />
      <Route path="delete" element={<ResistanceTrendDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ResistanceTrendRoutes;
